import { Text } from "@chakra-ui/react";
import { useDeleteBankAccountMutation, useGetFiatAccountQuery } from "apis";
import { useState } from "react";
import BankCard from "./BankCard";

const ListBanks = () => {
  const { data, isSuccess } = useGetFiatAccountQuery({});

  const [_deleteBankAccount, { isLoading }] = useDeleteBankAccountMutation();
  const [fiatId, setFiatId] = useState("");

  const handleDelete = async (id: string) => {
    setFiatId(id);
    await _deleteBankAccount(id);
  };

  return (
    <>
      {data?.BankAccount?.map(({ accountName, fiatAccountId, institutionName }) => {
        return (
          <BankCard
            accountName={accountName}
            fiatAccountId={fiatAccountId}
            institutionName={institutionName}
            handleDelete={() => handleDelete(fiatAccountId)}
            deleteLoading={isLoading}
            selectedFiatId={fiatId}
          />
        );
      })}

      {data?.MobileMoney?.map(({ accountName, fiatAccountId, institutionName }) => {
        return (
          <BankCard
            accountName={accountName}
            fiatAccountId={fiatAccountId}
            institutionName={institutionName}
            handleDelete={() => handleDelete(fiatAccountId)}
            deleteLoading={isLoading}
            selectedFiatId={fiatId}
          />
        );
      })}

      {isSuccess && Object.values(data!).length === 0 && (
        <Text textAlign="center" fontSize="18px" mt="24px">
          You don't have fiat account
        </Text>
      )}
    </>
  );
};
export default ListBanks;
